import React, { Component } from "react";
import {
  Box,
  Table,
  TableBody,
  TableHeader,
  TableRow,
  Text,
  TableCell
} from "grommet";

export class StationView extends Component {
  state = {
    tableRows: []
  };

  getPrettyDateString = dateString => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);

    let differenceString = difference.toISOString().substr(11, 8);
    const diffArray = differenceString.split(":");
    if (diffArray[0] === "00") {
      differenceString = diffArray[1] + ":" + diffArray[2];
    }
    return differenceString;
  };

  updateRowData = shiftGuards => {
    let tableRows = [];

    shiftGuards.forEach(shiftGuard => {
      const roleInstances = shiftGuard.RoleInstances;
      if (typeof roleInstances == "object") {
        roleInstances.forEach(roleInstance => {
          const role = roleInstance.Role;
          let tableRowElement;

          const timeStart = this.getPrettyDateString(roleInstance.timeStart);
          const DateTimeEnd = this.getPrettyDateString(
            roleInstance.DateTimeEnd
          );
          if (role.Type === "Station") {
            tableRowElement = {
              guardName: shiftGuard.Gaurd.GaurdFirstName,
              startTime: timeStart,
              endTime: DateTimeEnd,
              timeStationed: this.getTimeDifference(
                roleInstance.timeStart,
                roleInstance.DateTimeEnd
              )
            };
            tableRows.push(tableRowElement);
          }
        });
      }
    });

    const newState = {
      ...this.state,
      tableRows: tableRows
    };
    this.setState(newState);
  };

  componentDidMount = () => {
    this.updateRowData(this.props.shiftData.Shift_Gaurds);
  };

  /*
  componentDidUpdate = () => {
    this.updateRowData(this.props.shiftData.Shift_Gaurds);
  };*/

  getStringFromSeconds = timeTaken => {
    const hours = Math.floor(timeTaken / 3600);
    timeTaken %= 3600;
    const minutes = Math.floor(timeTaken / 60);
    const seconds = timeTaken % 60;

    let minuteString;
    let secondString;
    let hoursString;

    if (hours < 10) {
      hoursString = "0" + hours;
    } else {
      hoursString = "" + hours;
    }

    if (minutes < 10) {
      minuteString = "0" + minutes;
    } else {
      minuteString = "" + minutes;
    }

    if (seconds < 10) {
      secondString = "0" + seconds;
    } else {
      secondString = "" + seconds;
    }

    const timeString = hoursString + ":" + minuteString + ":" + secondString;
    return timeString;
  };

  render() {
    const tableRows = this.state.tableRows;
    return (
      <Box>
        <Table>
          <TableHeader>
            <TableRow>
              <TableCell scope="col" border="bottom">
                Guard Name
              </TableCell>
              <TableCell scope="col" border="bottom">
                Station Start Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Station End Time
              </TableCell>
              <TableCell scope="col" border="bottom">
                Time Stationed
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tableRows.map((tableRow, index) => {
              return (
                <TableRow key={index}>
                  <TableCell scope="row">
                    <Text>{tableRow.guardName}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.startTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.endTime}</Text>
                  </TableCell>
                  <TableCell>
                    <Text>{tableRow.timeStationed}</Text>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }
}

export default StationView;
